import Box from "@mui/material/Box"
import { useTheme } from "@mui/material/styles"

const PositionGrid = () => {
  const theme = useTheme()
  const strokeColor = theme.palette.neutral[900]

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
      }}
    >
      <svg width="100%" height="100%">
        <defs>
          <pattern
            id="position-grid"
            width="60"
            height="60"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M 60 0 L 0 0 0 60"
              fill="none"
              stroke={strokeColor}
              strokeWidth="1"
              strokeDasharray="3 3"
              opacity="0.08"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#position-grid)" />
      </svg>
    </Box>
  )
}

export default PositionGrid
